import styled from 'styled-components';
import media from '../../../utils/mediaQueries';
import { FONT_FAMILY_MAIN } from '../../../theme';

export const Input = styled.input`
  height: 48px;
  padding: 1px 16px;
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.07);
  background-color: #f4f7f9;
  outline: none;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.2px;
  color: #354354;
  transition: all .2s;
  font-family: ${FONT_FAMILY_MAIN};
  ${(props) => props.icon && `
    background-image: url(${props.icon});
    background-repeat: no-repeat;
  `}
  ${(props) => props.iconPosition === 'right' ? `
    padding-right: 42px;
    background-position: right 9px center;
  ` : `
    padding-left: 42px;
    background-position: 14px center;
  `}
  &:focus {
    border-color: #23c4f8 !important;
  }
  &::placeholder {
    color: #ccd0d4; 
  }
  ${(props) => props.disabled
    ? `
    border: dashed 1px rgba(0, 0, 0, 0.07);
    color: #9aa1a9;
    &:hover {
      cursor: not-allowed;
    }
  `
    : `
    &:hover {
      border-color: rgba(41, 83, 102, 0.3);
    }
  `}
  ${(props) => props.valid === true
    && `
    border-color: #51e3ae !important;
  `}
  ${(props) => props.valid === false
    && `
    border-color: #f74656 !important;
    color: #f74656;
  `}
  width: ${(props) => (props.width ? props.width : 'auto')};
  
  ${media.mobile`
    font-size: 16px;
    
    &:focus {
      font-size: 16px;
    }
  `}
`;
